import { useTranslation } from 'react-i18next';
import { ButtonLink } from '@anytag/shared-atoms';
import { useAgencyPermissions } from '@anytag/auth';
import { useAllAgenciesQuery } from '@anytag/graphql';
import { Header, ListWithPagination } from '@anytag/shared-molecules';
import { getOffset, getValuableVariables } from '@anytag/shared-utils';
import { useUpdateDocumentTitle } from '@anytag/shared-hooks';
import { AgenciesFilter, AgenciesList, useAccountsFilter } from '@anytag/shared-organisms';

export const Agencies = () => {
  useUpdateDocumentTitle({ title: 'appHeader.Agency', appHeader: 'appHeader.Agency' });
  const { t } = useTranslation();
  const { hideAddAgencyBtn } = useAgencyPermissions();
  const { page, limit, filter } = useAccountsFilter();
  const { data, previousData, loading } = useAllAgenciesQuery({
    fetchPolicy: 'network-only',
    variables: getValuableVariables({
      ...filter,
      limit,
      offset: getOffset(page, limit),
      verifiedStatus: filter.verifiedStatus || null
    })
  });

  const result = loading ? previousData : data;
  const totalRecords = result?.allAgenciesCount?.totalNumber;

  return (
    <div>
      <Header>
        {!hideAddAgencyBtn ? (
          <ButtonLink
            variant="solid"
            to="/agency/add"
            className="ml-auto min-w-35 capitalize"
            title={t<string>('Button.Add Agency')}
            prefixIcon={{ icon: 'plus', size: '10px' }}
          />
        ) : null}
      </Header>

      <ListWithPagination pagination={{ totalRecords }}>
        <AgenciesFilter />
        <AgenciesList loading={loading} totalRecords={totalRecords} data={result?.allAgencies || []} />
      </ListWithPagination>
    </div>
  );
};
